import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export function useAppointableEnable({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (appointableId: number) => {
      return await api.appointableApi.active(appointableId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointableQueryKeys.all() });
    },
  });
}
